/* eslint-disable no-multi-str */
import React from "react"
import SectionContainer from "../components/SectionContainer"
import ExpViewBuilder from "./ExpViewBuilder"

import saplogo from "../images/saplogo.png"
import drexelLogo from "../images/drexellogo.jpg"
import reactLogo from "../images/reactlogo2.png"
import wasmLogo from "../images/wasmlogo.png"
import sapLogo from "../images/saplogo.png"

const jobs = [
  {
    projectrole: "Frontend Developer",
    teamname: "Innovative Technology Integration",
    totaltime: "8 Months",
    startandend: "Sep'19 - Apr'20",
    companylogo: sapLogo,
    companyname: "SAP",
    description: "Researched web technology innovations, and created \
                  compelling business cases to integrate them into the development pipeline.",
    projects: [
      {
        name: "Progressive Web Apps",
        points: [
          "Developed a proof-of-concept, cross-platform application for the \
          office fitness center using PWA technology and React",
          "Researched industry use of PWA at scale, focusing on the pros and cons",
          "Presented a business case to build PWAs instead of native mobile apps",
        ]
      },
      {
        name: "WebAssembly",
        points: [
          "Built a demo to showcase C++ and Rust code running on the browser",
          "Developed a business case for using WebAssembly to improve data \
          processing performance on web apps",
        ]
      },
    ],
    relatedskills: [
      {
        name: "React",
        icon: reactLogo,
        proficiency: "Proficient"
      },
      {
        name: "WebAssembly",
        icon: wasmLogo,
        proficiency: "Familiar"
      },
    ]
  },
  {
    projectrole: "Project Lead",
    teamname: "Service Support Applications",
    totaltime: "1 Year",
    startandend: "Aug'18 - Aug'19",
    companylogo: sapLogo,
    companyname: "SAP",
    description: "Created tools and services to improve the workflow \
                  of a high-priority-customer support team of 30+ members.",
    projects: [
      {
        name: "Call Logging and Report Automation",
        points: [
          "Developed a fullstack application to improve call logging \
          and automatically generate graphical reports. This tool saves \
          the team several hours of work every month",
          "Led a team of 4 through the full product lifecycle. \
          Completed the project under a tight deadline and budget constraints",
          "Communicated with the business to gather requirements and resources",
        ]
      },
      {
        name: "Employee Assessment Tool",
        points: [
          "Developed a fullstack application for team leads \
          across the department to assess and evaluate employees \
          coming in for temporary assignments",
        ]
      },
    ],
    relatedskills: [
      {
        name: "SAPUI5",
        icon: sapLogo,
        proficiency: "Proficient"
      },
      {
        name: "HANAXS",
        icon: sapLogo,
        proficiency: "Familiar"
      },
    ]
  },
  {
    projectrole: "Fullstack Developer",
    teamname: "Internal Applications",
    totaltime: "1 Year",
    startandend: "Sep'17 - Aug'18",
    companyname: "SAP",
    companylogo: saplogo,
    description: "Shared responsibilities with the team lead for \
                  maintaining and supporting an application with 12,000+ users.",
    projects: [
      {
        name: "Product Pricing Application",
        points: [
          "Developed frontend views and custom components to improve user experience",
          "Created backend programs for easier data input and web services to \
          deliver the data to the frontend",
        ]
      },
    ],
    relatedskills: [
      {
        name: "SAPUI5",
        icon: sapLogo,
        proficiency: "Proficient"
      },
      {
        name: "Netweaver",
        icon: sapLogo,
        proficiency: "Familiar"
      },
    ]
  },
  {
    projectrole: "IT Intern",
    teamname: "IRT Office",
    totaltime: "6 Months",
    startandend: "Sep'16 - Mar'17",
    companyname: "Drexel IT",
    companylogo: drexelLogo,
    description: "Helped a team of 6 with their daily operations.",
    projects: [
      {
        name: "Miscellaneous",
        points: [
          "Wrote SQL queries to create the logic for student financial aid",
          "Created MS Excel lookup algorithms to speed up the team's workflow",
          "Processed and cleaned data to prepare it for database migration"
        ]
      },
    ],
  },
]

const ProfessionalExp = () => (
  <SectionContainer header="Professional">
    <ExpViewBuilder jobs={jobs} />
  </SectionContainer>
)

export default ProfessionalExp